import { createI18n } from 'vue-i18n';
import enLocale from './locales/en.json';
import ukLocale from './locales/uk.json';

const messages = {
  en: enLocale,
  uk: ukLocale
};

const SUPPORTED = Object.keys(messages);
const DEFAULT_LOCALE = 'uk';

/*
 * A stored choice always wins. Otherwise match the browser, falling back to
 * Ukrainian — the UI, the audience and the better-written copy are all
 * Ukrainian-first, but the default used to be English.
 */
function resolveLocale() {
  const saved = localStorage.getItem('locale');
  if (saved && SUPPORTED.includes(saved)) return saved;

  const preferred = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const tag of preferred) {
    const base = String(tag || '').toLowerCase().split('-')[0];
    if (SUPPORTED.includes(base)) return base;
  }

  return DEFAULT_LOCALE;
}

const i18n = createI18n({
  legacy: false, // you must set `false`, to use Composition API
  locale: resolveLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages,
  /*
   * Warnings are on in development. They were suppressed across the board,
   * so a missing key rendered its own raw path with nothing in the console.
   */
  silentTranslationWarn: import.meta.env.PROD,
  silentFallbackWarn: import.meta.env.PROD,
  missingWarn: !import.meta.env.PROD,
  fallbackWarn: !import.meta.env.PROD
});

export default i18n;
